/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { useHistory, useParams } from 'react-router';

import {
  Button,
  Divider,
  FormControl,
  FormLabel,
  Grid,
  makeStyles,
  RadioGroup,
  Theme,
  Typography,
} from '@material-ui/core';

import Input from '../../../components/Input';
import CustomRadio from '../../../components/Radio';
import Snackbar, { AlertComponentProps } from '../../../components/Snackbar';
import { useAxios } from '../../../utils/hooks';
import { Form as FormModel } from '../../../models/form';
import Loader from '../../../components/Loader';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    background: 'white',
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  formTitles: {
    fontWeight: 'bolder',
  },
  formControl: {
    margin: theme.spacing(2, 0),
  },
  divider: {
    margin: theme.spacing(2),
  },
}));

const UpdateForm: React.FC = () => {
  const api = useAxios();
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState<FormModel | null>(null);
  const { formId } = useParams<{ id: string; formId: string }>();

  const formRef = useRef<FormHandles>(null);

  const [alert, setAlert] = useState<
    AlertComponentProps & { isActive: boolean }
  >({
    isActive: false,
    type: 'info',
    message: 'none',
  });

  useEffect(() => {
    async function getInitFormData() {
      try {
        const formResponse = await api.current?.get(`/forms/${formId}`);

        setForm(formResponse?.data);
      } catch (error) {
        setAlert({
          isActive: true,
          type: 'error',
          message: 'Erro ao carregar formulário.',
        });
      } finally {
        setLoading(false);
      }
    }

    getInitFormData();
  }, [api, formId]);

  return (
    <>
      <Loader loading={loading} />

      {!loading && (
        <Form
          id="form"
          ref={formRef}
          initialData={form?.answers}
          onSubmit={() => console.log('submit')}
          className={classes.root}
        >
          <FormControl fullWidth className={classes.formControl}>
            <Typography
              variant="h5"
              component="h1"
              align="center"
              className={classes.formTitles}
            >
              Ficha de Atualização de Cadastro
            </Typography>

            <Typography
              variant="h6"
              component="h6"
              align="center"
              className={classes.formTitles}
            >
              (preenchida pelo paciente ou responsável referente a modificações
              na ficha cadastral)
            </Typography>

            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <FormLabel className={classes.formTitles}>
              DADOS DE IDENTIFICAÇÃO
            </FormLabel>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  1 - DO PACIENTE:
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="patient_name"
                  label="Nome"
                  name="patient_name"
                />
              </Grid>

              <Grid item xs={3}>
                <Input
                  disabled
                  id="patient_gender"
                  label="Gênero"
                  name="patient_gender"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  disabled
                  id="patient_race"
                  label="Raça/cor"
                  name="patient_race"
                />
              </Grid>

              <Grid item xs={5}>
                <Input
                  disabled
                  id="patient_birth"
                  label="Data de Nascimento"
                  name="patient_birth"
                  placeholder="23/02/1997"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  disabled
                  id="patient_age"
                  label="Idade"
                  name="patient_age"
                />
              </Grid>

              {/* <Grid item xs={4}>
                <Input disabled id="patient_rg" label="RG" name="patient_rg" />
              </Grid> */}

              {/* TODO: 'cpf-cnpj-validator' */}

              <Grid item xs={4}>
                <Input
                  disabled
                  id="patient_cpf"
                  label="CPF"
                  name="patient_cpf"
                />
              </Grid>
              {/*
              <Grid item xs={4}>
                <Input
                  disabled id="patient_certidao"
                  label="Certidão de Nascimento"
                  name="patient_certidao"
                />
              </Grid> */}

              <Grid item xs={12}>
                <Input
                  disabled
                  id="patient_birth_local"
                  label="Local de Nascimento"
                  name="patient_birth_local"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="patient_phone"
                  label="Telefone"
                  name="patient_phone"
                  placeholder="(__) _______"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>ENDEREÇO:</FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="address_street"
                  label="Logradouro"
                  name="address_street"
                  placeholder="Rua/Av./Denominação/número/complemento"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="address_neighborhood"
                  label="Bairro"
                  name="address_neighborhood"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="address_city"
                  label="Cidade"
                  name="address_city"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="address_zipcode"
                  label="CEP"
                  name="address_zipcode"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  ESCOLARIDADE:
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <RadioGroup row>
                  <CustomRadio
                    disabled
                    name="school_level"
                    options={[
                      {
                        id: '1',
                        value: 'kid_school',
                        label: 'Educação Infantil',
                      },
                      {
                        id: '2',
                        value: 'fundamental_school',
                        label: 'Ensino Fundamental',
                      },
                      {
                        id: '3',
                        value: 'middle_school',
                        label: 'Ensino Médio',
                      },
                      { id: '4', value: 'school_level_other', label: 'Outro' },
                    ]}
                  />

                  {/* <Input disabled id="school_level" label="Outro" name="school_level" /> */}
                </RadioGroup>
              </Grid>

              <Grid item xs={3}>
                <Input
                  disabled
                  id="school_year"
                  label="Ano"
                  name="school_year"
                />
              </Grid>

              <Grid item xs={3}>
                <Input
                  disabled
                  id="school_period"
                  label="Turno"
                  name="school_period"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="school_fails"
                  label="Número de repetências"
                  name="school_fails"
                />
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="school_name"
                  label="Nome da Escola"
                  name="school_name"
                />
              </Grid>

              <Grid item xs={12}>
                <RadioGroup row>
                  <CustomRadio
                    disabled
                    name="school_type"
                    options={[
                      {
                        id: '1',
                        value: 'city_school',
                        label: 'Escola Municipal',
                      },
                      {
                        id: '2',
                        value: 'state_school',
                        label: 'Escola Estadual',
                      },
                      {
                        id: '3',
                        value: 'private_school',
                        label: 'Escola Privada',
                      },
                      { id: '4', value: 'school_level_other', label: 'Outro' },
                    ]}
                  />
                </RadioGroup>
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  2 - DOS RESPONSÁVEIS:
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Responsável 1
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="responsible_1_name"
                  label="Nome"
                  name="responsible_1_name"
                />
              </Grid>

              <Grid item xs={3}>
                <Input
                  disabled
                  id="responsible_1_rg"
                  label="RG"
                  name="responsible_1_rg"
                />
              </Grid>

              <Grid item xs={3}>
                <Input
                  disabled
                  id="responsible_1_cpf"
                  label="CPF"
                  name="responsible_1_cpf"
                />
              </Grid>

              <Grid item xs={3}>
                <Input
                  disabled
                  id="responsible_1_birth"
                  label="Data de Nascimento"
                  placeholder="23/02/1997"
                  name="responsible_1_birth"
                />
              </Grid>

              <Grid item xs={3}>
                <Input
                  id="responsible_1_race"
                  label="Raça/cor"
                  name="responsible_1_race"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="responsible_1_civil_situation"
                  label="Estado Civil"
                  name="responsible_1_civil_situation"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="responsible_1_guard_type"
                  label="Tipo de Guarda"
                  name="responsible_1_guard_type"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="responsible_1_phone_1"
                  label="Telefones"
                  name="responsible_1_phone_1"
                  placeholder="(__) _______"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="responsible_1_phone_2"
                  label="Telefones"
                  name="responsible_1_phone_2"
                  placeholder="(__) _______"
                />
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="responsible_1_email"
                  label="E-mail"
                  name="responsible_1_email"
                />
              </Grid>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Grau de parentesco com o paciente:
                </FormLabel>

                <RadioGroup row>
                  <CustomRadio
                    disabled
                    name="responsible_1_parent"
                    options={[
                      { id: '1', value: 'mother', label: 'Mãe' },
                      {
                        id: '2',
                        value: 'father',
                        label: 'Pai',
                      },
                      { id: '3', value: 'other', label: 'Outro' },
                    ]}
                  />
                </RadioGroup>

                <Input
                  disabled
                  id="responsible_1_parent_other"
                  label="Outro"
                  name="responsible_1_parent_other"
                />
              </Grid>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Grau de Instrução:
                </FormLabel>

                <RadioGroup row>
                  <CustomRadio
                    disabled
                    name="responsible_1_school_level"
                    options={[
                      {
                        id: '1',
                        value: 'fundamental_school',
                        label: 'Ensino Fundamental',
                      },
                      {
                        id: '2',
                        value: 'middle_school',
                        label: 'Ensino Médio',
                      },
                      {
                        id: '3',
                        value: 'superior_school',
                        label: 'Ensino Superior',
                      },
                      { id: '4', value: 'other', label: 'Outro' },
                    ]}
                  />
                </RadioGroup>

                <Input
                  disabled
                  id="responsible_1_school_level_other"
                  label="Outros"
                  name="responsible_1_school_level_other"
                />
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="responsible_1_profession"
                  label="Profissão"
                  name="responsible_1_profession"
                />
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="responsible_1_income"
                  label="Renda (R$)"
                  name="responsible_1_income"
                />
              </Grid>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Responsável 2
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="responsible_2_name"
                  label="Nome"
                  name="responsible_2_name"
                />
              </Grid>

              <Grid item xs={3}>
                <Input
                  disabled
                  id="responsible_2_rg"
                  label="RG"
                  name="responsible_2_rg"
                />
              </Grid>

              <Grid item xs={3}>
                <Input
                  disabled
                  id="responsible_2_cpf"
                  label="CPF"
                  name="responsible_2_cpf"
                />
              </Grid>

              <Grid item xs={3}>
                <Input
                  disabled
                  id="responsible_2_birth"
                  label="Data de Nascimento"
                  placeholder="23/02/1997"
                  name="responsible_2_birth"
                />
              </Grid>

              <Grid item xs={3}>
                <Input
                  id="responsible_2_race"
                  label="Raça/cor"
                  name="responsible_2_race"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="responsible_2_civil_situation"
                  label="Estado Civil"
                  name="responsible_2_civil_situation"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="responsible_2_guard_type"
                  label="Tipo de Guarda"
                  name="responsible_2_guard_type"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="responsible_2_phone_2"
                  label="Telefones"
                  name="responsible_2_phone_2"
                  placeholder="(__) _______"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="responsible_2_phone_2"
                  label="Telefones"
                  name="responsible_2_phone_2"
                  placeholder="(__) _______"
                />
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="responsible_2_email"
                  label="E-mail"
                  name="responsible_2_email"
                />
              </Grid>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Grau de parentesco com o paciente:
                </FormLabel>

                <RadioGroup row>
                  <CustomRadio
                    disabled
                    name="responsible_2_parent"
                    options={[
                      { id: '1', value: 'mother', label: 'Mãe' },
                      {
                        id: '2',
                        value: 'father',
                        label: 'Pai',
                      },
                      { id: '3', value: 'other', label: 'Outro' },
                    ]}
                  />
                </RadioGroup>

                <Input
                  disabled
                  id="responsible_2_parent_other"
                  label="Outro"
                  name="responsible_2_parent_other"
                />
              </Grid>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Grau de Instrução:
                </FormLabel>

                <RadioGroup row>
                  <CustomRadio
                    disabled
                    name="responsible_2_school_level"
                    options={[
                      {
                        id: '1',
                        value: 'fundamental_school',
                        label: 'Ensino Fundamental',
                      },
                      {
                        id: '2',
                        value: 'middle_school',
                        label: 'Ensino Médio',
                      },
                      {
                        id: '3',
                        value: 'superior_school',
                        label: 'Ensino Superior',
                      },
                      { id: '4', value: 'other', label: 'Outro' },
                    ]}
                  />
                </RadioGroup>

                <Input
                  disabled
                  id="responsible_2_school_level_other"
                  label="Outro"
                  name="responsible_2_school_level_other"
                />
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="responsible_2_profession"
                  label="Profissão"
                  name="responsible_2_profession"
                />
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="responsible_2_income"
                  label="Renda (R$)"
                  name="responsible_2_income"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Responsável pelo custeio do tratamento:
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="payer_same"
                  label="Mesmos acima"
                  name="payer_same"
                />
                <Input
                  disabled
                  id="payer_other"
                  label="Outro"
                  name="payer_other"
                />
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="payer_parent"
                  label="Grau de parentesco com o paciente (se houver)"
                  name="payer_parent"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="payer_phone"
                  label="Telefone"
                  name="payer_phone"
                  placeholder="(__) _______"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="payer_income"
                  label="Renda (R$)"
                  name="payer_income"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  MOTIVO DA PROCURA AO CEAPIA:
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  id="motive"
                  label="Descreva brevemente quais são e quando começaram as questões que os trazem ao CEAPIA"
                  disabled
                  name="motive"
                  isMultiline
                  rows={5}
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  RELAÇÃO DE TODAS AS PESSOAS QUE RESIDEM NA CASA COM O
                  PACIENTE:
                </FormLabel>
              </Grid>

              {/* 1) */}
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_1_name"
                  label="Nome"
                  name="resident_1_name"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_1_age"
                  label="Idade"
                  name="resident_1_age"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_1_parent"
                  label="Parentesco"
                  name="resident_1_parent"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_1_ocupation"
                  label="Ocupação"
                  name="resident_1_ocupation"
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              {/* 2) */}
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_2_name"
                  label="Nome"
                  name="resident_2_name"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_2_age"
                  label="Idade"
                  name="resident_2_age"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_2_parent"
                  label="Parentesco"
                  name="resident_2_parent"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_2_ocupation"
                  label="Ocupação"
                  name="resident_2_ocupation"
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              {/* 3) */}
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_3_name"
                  label="Nome"
                  name="resident_3_name"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_3_age"
                  label="Idade"
                  name="resident_3_age"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_3_parent"
                  label="Parentesco"
                  name="resident_3_parent"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_3_ocupation"
                  label="Ocupação"
                  name="resident_3_ocupation"
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              {/* 4) */}
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_4_name"
                  label="Nome"
                  name="resident_4_name"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_4_age"
                  label="Idade"
                  name="resident_4_age"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_4_parent"
                  label="Parentesco"
                  name="resident_4_parent"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_4_ocupation"
                  label="Ocupação"
                  name="resident_4_ocupation"
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              {/* 5) */}
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_5_name"
                  label="Nome"
                  name="resident_5_name"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_5_age"
                  label="Idade"
                  name="resident_5_age"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_5_parent"
                  label="Parentesco"
                  name="resident_5_parent"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_5_ocupation"
                  label="Ocupação"
                  name="resident_5_ocupation"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formTitles}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                Diretora de Atendimento
              </Grid>

              <Grid item xs={6}>
                Assinatura do responsável
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formTitles}>
            <Grid container spacing={2} justify="flex-end">
              <Grid item xs={2}>
                <Input
                  disabled
                  id="form_data"
                  label="Data"
                  name="form_data"
                  defaultValue={moment().format('DD/MM/YYYY').toString()}
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formTitles}>
            <Grid container spacing={1} justify="center">
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => history.goBack()}
                >
                  Voltar
                </Button>
              </Grid>
            </Grid>
          </FormControl>
        </Form>
      )}

      {alert.isActive && <Snackbar {...alert} />}
    </>
  );
};

export default UpdateForm;
